import BaseApi from "./Api";

class CompetitionsApi extends BaseApi {
  url = "competitions";
  constructor() {
    super();
    this.setResourceUrl(this.url);
  }

  delete = (id: string, active: boolean = false) => {
    return this.instance({
      method: "delete",
      url: `${this.resourceUrl}/${id}`,
      data: {
        active,
      },
    });
  };

  /** New owner must already be in `accessor` (shared organiser). */
  transferOwner = (id: string, newOwnerId: string) => {
    return this.instance({
      method: "post",
      url: `${this.resourceUrl}/${id}/transfer-owner`,
      data: { newOwnerId },
    });
  };
}

export default new CompetitionsApi();
